type PackagesPageProps = {
  packages: [];
};

const packagesPage: PackagesPageProps = {
  packages: []
};

export default packagesPage;
